import { Button } from '@/components/ui/button';
import { useLanguage } from '@/hooks/useLanguage';
import { useLocation, useNavigate } from 'react-router-dom';

export function LanguageSelector() {
  const { language, setLanguage } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();

  const updateUrlForLanguage = (newLang: 'it' | 'es' | 'en') => {
    const pathname = location.pathname;
    const search = location.search || '';
    const hash = location.hash || '';

    // 1) If suffix form: /blog/:slug/:lang -> replace suffix
    const suffixMatch = pathname.match(/^\/blog\/(.+)\/(it|es|en)$/);
    if (suffixMatch) {
      const slug = suffixMatch[1];
      const nextPath = `/blog/${slug}/${newLang}`;
      navigate(`${nextPath}${search}${hash}`);
      return;
    }

    // 2) If prefix form: /:lang/... -> replace first segment
    const prefixMatch = pathname.match(/^\/(it|es|en)(\/.*)?$/);
    if (prefixMatch) {
      const rest = prefixMatch[2] || '';
      const nextPath = newLang === 'it' ? (rest || '/') : `/${newLang}${rest || ''}`;
      navigate(`${nextPath}${search}${hash}`);
      return;
    }

    // 3) No language in URL -> add prefix (canonical)
    const nextPath = newLang === 'it' ? pathname || '/' : `/${newLang}${pathname || ''}`;
    navigate(`${nextPath}${search}${hash}`);
  };

  return (
    <div className="flex gap-2">
      <Button
        variant={language === 'it' ? 'default' : 'outline'}
        size="sm"
        onClick={() => { setLanguage('it'); updateUrlForLanguage('it'); }}
      >
        IT
      </Button>
      <Button
        variant={language === 'es' ? 'default' : 'outline'}
        size="sm"
        onClick={() => { setLanguage('es'); updateUrlForLanguage('es'); }}
      >
        ES
      </Button>
      <Button
        variant={language === 'en' ? 'default' : 'outline'}
        size="sm"
        onClick={() => { setLanguage('en'); updateUrlForLanguage('en'); }}
      >
        EN
      </Button>
    </div>
  );
}